import React from 'react'
import {ReactComponent as BookIcon} from '../assets/icons/book.svg';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YoutubeIcon2 from '@mui/icons-material/YouTube';
import styled from 'styled-components';
import { PRIMARY } from '../const/colors';

const Box = styled.div`
  position: relative;

  a {
    width: 42px;
    height: 42px;
    display: inline-flex;
    border-radius: 50%;
    margin-right: 6px;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }
  a::before {
    content: "";
    width: 42px;
    height: 42px;
    position: absolute;
    background-color: #ffffff;
    border-radius: 50%;
    transform: scale(0);
	  transition: 0.3s ease-in-out;
  }
  a:hover::before {
      transform: scale(1);
  }
  a svg {
    font-size: ${props=> props.nav ? '21px' : '22px'};
    margin: 0 10px;
    color: ${PRIMARY};
  }
  a:hover svg {
    filter: brightness(0) saturate(100%) invert(0%) sepia(7%) saturate(98%) hue-rotate(346deg) brightness(95%) contrast(86%);
  }
`

const SocialMedia = ({nav}) => {
  return (
    <Box nav={nav}>
      <a href="https://blog.masterbets365.com/" rel="noopener noreferrer" target="_blank">
        <BookIcon />
      </a>
      <a href="https://www.facebook.com/masterbets365" rel="noopener noreferrer" target="_blank">
        <FacebookIcon />
      </a>
      <a href="https://www.instagram.com/masterbets365/" rel="noopener noreferrer" target="_blank">
        <InstagramIcon />
      </a>
      {
        (nav) ? <a href="https://www.linkedin.com/company/masterbets365/" rel="noopener noreferrer" target="_blank">
        <LinkedInIcon /></a> : ""
      }
      <a href="https://twitter.com/mastbets365?lang=es" rel="noopener noreferrer" target="_blank">
        <TwitterIcon />
      </a>
      <a href="https://www.youtube.com/channel/UCTvRlWPrtlWW149Qab-vuIw" rel="noopener noreferrer" target="_blank">
        <YoutubeIcon2 />
      </a>
    </ Box>
  )
}

export default SocialMedia